// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"93d402ec","112":"cf012b99","176":"0042e351","204":"02942ab0","226":"018eef11","453":"28bf7136"}[chunkId] + ".chunk.js";
};